import { useEffect } from 'react'
import type { UseFormReturn, FieldValues } from 'react-hook-form'

const STORAGE_KEY = 'aquatic_form_data'

export function useFormPersistence<T extends FieldValues>(
  form: UseFormReturn<T>,
  enabled = true
) {
  const { watch, reset } = form

  // Load saved data on mount
  useEffect(() => {
    if (!enabled) return

    try {
      const saved = sessionStorage.getItem(STORAGE_KEY)
      if (saved) {
        const data = JSON.parse(saved)
        reset(data, { keepDefaultValues: true })
      }
    } catch (error) {
      console.error('Failed to load form data:', error)
    }
  }, [enabled, reset])

  // Save data on change
  useEffect(() => {
    if (!enabled) return

    const subscription = watch((data) => {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data))
      } catch (error) {
        console.error('Failed to save form data:', error)
      }
    })

    return () => subscription.unsubscribe()
  }, [enabled, watch])

  const clearSavedData = () => {
    sessionStorage.removeItem(STORAGE_KEY)
  }

  return { clearSavedData }
}
